import { Dialog, DialogBackdrop, DialogPanel } from "@headlessui/react";
import React, { Fragment } from "react";
import { ButtonSecondaryModal } from "../atoms/ButtonSecondaryModal";
import { PlusIcon } from "@heroicons/react/20/solid";
import { ButtonPrimaryModal } from "../atoms/ButtonPrimaryModal";
import { classNames } from "@/shared/utils/classnames";

type Tab = {
  id: number;
  name: string;
};

type ModalWithTabsProps = {
  onClickCreate?: () => void;
  Close: () => void;
  open: boolean;
  textButtonCreate?: string;
  textButtonClose?: string;
  children?: React.ReactNode;
  textButtonTopCreate?: string;
  functionButtonTopCreate?: () => void;
  tabs: Tab[];
  selectedTab: number;
  setSelectedTab: (tabId: number) => void;
  modalClassName?: string
};

export const ModalWithTabs: React.FC<ModalWithTabsProps> = ({
  onClickCreate,
  Close,
  open,
  textButtonCreate,
  textButtonClose,
  children,
  functionButtonTopCreate,
  tabs,
  selectedTab,
  setSelectedTab,
  modalClassName,
}) => {
  const handleTabChange = (tabId: number) => {
    setSelectedTab(tabId);
  };

  return (
    <Fragment>
      <Dialog open={open} onClose={Close} className={classNames("relative z-10", modalClassName)}>
        <DialogBackdrop
          transition
          className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in"
        />

        <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
          <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
            <DialogPanel
              transition
              className="relative transform overflow-visible rounded-lg bg-white text-left shadow-xl transition-all data-[closed]:translate-y-4 data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in sm:my-8 w-full sm:max-w-xl lg:max-w-5xl sm:max-w-xl  data-[closed]:sm:translate-y-0 data-[closed]:sm:scale-95"
            >
              <div className="bg-white px-4 pb-4 pt-5 sm:p-6 sm:pb-4">
                <div className="">
                  <div className="flex justify-between items-center">
                    <div className="flex-1 mt-4">
                      <div className="sm:hidden">
                        <label htmlFor="tabs" className="sr-only">
                          Select a tab
                        </label>
                        <select
                          id="tabs"
                          name="tabs"
                          value={selectedTab}
                          onChange={(e) =>
                            handleTabChange(Number(e.target.value))
                          } // Detectar cambio en el select
                          className="block w-full rounded-md border-gray-300 py-2 pl-3 pr-10 text-base focus:border-indigo-500 focus:outline-none focus:ring-indigo-500 sm:text-sm"
                        >
                          {tabs.map((tab) => (
                            <option key={tab.id} value={tab.id}>
                              {tab.name}
                            </option>
                          ))}
                        </select>
                      </div>

                      <div className="hidden sm:block">
                        <div className="border-b border-gray-200">
                          <nav
                            aria-label="Tabs"
                            className="-mb-px flex space-x-8"
                          >
                            {tabs.map((tab) => (
                              <button
                                key={tab.id}
                                onClick={() => handleTabChange(tab.id)} // Cambiar el tab seleccionado
                                className={`whitespace-nowrap border-b-2 px-1 py-4 text-sm font-medium ${
                                  selectedTab === tab.id
                                    ? "border-indigo-500 text-primary-600"
                                    : "border-transparent text-gray-500 hover:border-gray-300 hover:text-gray-700"
                                }`}
                              >
                                {tab.name}
                              </button>
                            ))}
                          </nav>
                        </div>
                      </div>
                    </div>

                    {/* Botón alineado con los tabs */}
                    <button
                      onClick={functionButtonTopCreate}
                      type="button"
                      className="mt-5 ml-4 block rounded-full border-2 border-dashed border-gray-400 p-1 text-gray-400 shadow-sm hover:text-gray-500 focus-visible:outline-none"
                    >
                      <PlusIcon aria-hidden="true" className="h-5 w-5" />
                    </button>
                  </div>

                  {/* Contenido del modal */}
                  <div className="mt-2">{children}</div>
                </div>
              </div>
              <div className="bg-gray-50 px-4 py-3 sm:flex sm:flex-row-reverse sm:px-6">
                <Fragment>
                  {textButtonCreate && onClickCreate && (
                    <ButtonPrimaryModal
                      text={textButtonCreate}
                      onClick={onClickCreate}
                    />
                  )}
                  {textButtonClose && (
                    <ButtonSecondaryModal
                      text={textButtonClose}
                      onClick={Close}
                    />
                  )}
                </Fragment>
              </div>
            </DialogPanel>
          </div>
        </div>
      </Dialog>
    </Fragment>
  );
};
